(() => {
    // Track bundles being processed to prevent infinite loops
    const processingBundles = new Set()

    // Debounce timer for setBundleCart
    let debounceTimer = null
    let isProcessing = false

    const getGuid = () => {
        let d = new Date().getTime()
        let d2 = (performance && performance.now && (performance.now() * 1000)) || 0
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16
            if (d > 0) {
                r = (d + r) % 16 | 0
                d = Math.floor(d / 16)
            } else {
                r = (d2 + r) % 16 | 0
                d2 = Math.floor(d2 / 16)
            }
            return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16)
        })
    }

    const cloneBundles = async (cart) => {
        const bundles = getBundles(cart)

        for (const [bundleId, bundle] of Object.entries(bundles)) {
            if (!bundle.parent || bundle.parent.quantity <= 1) continue
            if (processingBundles.has(bundleId)) continue

            processingBundles.add(bundleId)

            const extraQuantity = bundle.parent.quantity - 1
            const newItems = []

            // Create new bundles for each extra quantity
            for (let i = 0; i < extraQuantity; i++) {
                const newBundleId = getGuid()

                // Clone parent with new bundle_id
                const newParent = {
                    id: bundle.parent.variant_id,
                    quantity: 1,
                    properties: {
                        ...bundle.parent.properties,
                        bundle_id: newBundleId
                    }
                }
                if (bundle.parent.selling_plan_allocation) {
                    newParent.selling_plan = bundle.parent.selling_plan_allocation.selling_plan.id
                }
                newItems.push(newParent)

                // Clone children with new bundle_id
                bundle.items.forEach((child) => {
                    const newChild = {
                        id: child.variant_id,
                        quantity: child.quantity,
                        properties: {
                            ...child.properties,
                            bundle_id: newBundleId
                        }
                    }
                    if (child.selling_plan_allocation) {
                        newChild.selling_plan = child.selling_plan_allocation.selling_plan.id
                    }
                    newItems.push(newChild)
                })
            }

            // Update original parent quantity to 1
            try {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: bundle.parent.key,
                        quantity: 1
                    })
                })

                // Add cloned bundles
                if (newItems.length > 0) {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: newItems })
                    })
                }

                // Refresh Rebuy cart
                if (window.Rebuy && window.Rebuy.Cart) {
                    window.Rebuy.Cart.getCart()
                }
            } catch (error) {
                console.error('Error cloning bundle:', error)
            } finally {
                processingBundles.delete(bundleId)
            }
        }
    }

    const updateCartCount = (cart) => {
        // get real items
        let count = cart.items().filter((item) => !item.properties || !item.properties.bundle_id).reduce(
            (total, item) => total + item.quantity
            , 0)

        const bundles = getBundles(cart)
        count += Object.entries(bundles).filter(([_k, bundle]) => bundle.parent).reduce(
            (total, [_k, bundle]) => total + bundle.parent.quantity
            , 0)
        document.querySelector(".cart-menu .count").innerText = count;
        const stLabel = document.querySelector(".rebuy-cart__flyout-subtotal-label span")
        if (stLabel) {
            stLabel.innerText = stLabel.innerText.replace(/[0-9]+/, count)

        }


    }
    const setParentCartValue = (cart) => {
        const bundles = getBundles(cart)
        Object.entries(bundles).forEach(([k, bundle]) => {
            if (bundle.parent) {
                const total = bundle.items.reduce((total, item) => total + (item.quantity * item.price),
                    0) + bundle.parent.price
                const className = ".property-value-" + k.replace(/[-]/g, "") + ".property-key-bundle_parent"

                const elem = document.querySelector(className + " .rebuy-money")
                if (elem) {
                    elem.innerText = cart.formatMoney(total)
                }
            }
        })

    }

    const fixSubtotalCompareAt = (cart) => {
        const subtotalCompareEl = document.querySelector('.rebuy-cart__flyout-subtotal-compare-amount')
        if (!subtotalCompareEl) return

        const bundles = getBundles(cart)
        let correctCompareAt = 0

        // Add compare-at from bundle children using selling_plan_allocation.compare_at_price
        Object.values(bundles).forEach((bundle) => {
            if (bundle.parent) {
                bundle.items.forEach((child) => {
                    // Use selling_plan_allocation.compare_at_price for subscription items (per-unit price)
                    const perUnitCompareAt = child.selling_plan_allocation?.compare_at_price ||
                        child.product?.variants?.[0]?.compare_at_price ||
                        child.original_price ||
                        0
                    correctCompareAt += (perUnitCompareAt * child.quantity)
                })
            }
        })

        // Add compare-at from non-bundle items
        cart.items().forEach((item) => {
            if (item.properties?.bundle_id) return // Skip bundle items

            const perUnitCompareAt = item.selling_plan_allocation?.compare_at_price ||
                item.product?.variants?.[0]?.compare_at_price ||
                item.original_price ||
                0
            correctCompareAt += (perUnitCompareAt * item.quantity)
        })

        if (correctCompareAt > 0) {
            subtotalCompareEl.textContent = cart.formatMoney(correctCompareAt)
        }
    }

    const groupBundleItems = (cart) => {
        const bundles = getBundles(cart)
        const itemsContainer = document.querySelector('[data-smartcart-items]')
        if (!itemsContainer) return

        // Remove any previously added bundle group elements (headers, footers)
        document.querySelectorAll('.bundle-group-header, .bundle-group-footer').forEach(el => el.remove())
        document.querySelectorAll('.bundle-group-child').forEach(el => el.classList.remove('bundle-group-child'))
        document.querySelectorAll('.bundle-group-first').forEach(el => el.classList.remove('bundle-group-first'))
        document.querySelectorAll('.bundle-group-last').forEach(el => el.classList.remove('bundle-group-last'))

        // Remove hidden class from parents
        document.querySelectorAll('.bundle-group-parent-hidden').forEach(el => {
            el.classList.remove('bundle-group-parent-hidden')
        })

        Object.entries(bundles).forEach(([bundleId, bundle]) => {
            if (!bundle.parent || bundle.items.length === 0) return

            const bundleIdClean = bundleId.replace(/[-]/g, '')
            const isVirtualParent = bundle.parent._isVirtual === true

            // Find parent element (only for real parents, not virtual OTP parents)
            const parentEl = !isVirtualParent
                ? itemsContainer.querySelector(`.rebuy-cart__flyout-item.property-value-${bundleIdClean}.property-key-bundle_parent`)
                : null

            // For real parent bundles, require parent element in DOM
            if (!isVirtualParent && !parentEl) return

            // Find all child elements for this bundle
            const childEls = Array.from(itemsContainer.querySelectorAll(`.rebuy-cart__flyout-item.property-value-${bundleIdClean}.property-key-is_child`))
            if (childEls.length === 0) return

            // Get bundle info from parent (real or virtual)
            const bundleName = bundle.parent.properties.bundle || 'Bundle'
            const bundleSize = bundle.parent.properties.bundle_size || bundle.items.length
            const isSubscription = !!bundle.parent.selling_plan_allocation
            // OTP if: explicit _bundle_type='otp' OR no selling plan (regular bundle as one-time)
            const isOtpBundle = bundle.parent.properties._bundle_type === 'otp' || !isSubscription
            const bundleType = isSubscription ? 'subscription' : 'otp'

            // Calculate totals - use parent values (virtual parent already has calculated totals)
            let bundleTotal = bundle.parent.final_line_price || bundle.parent.price
            let bundleCompareAt = bundle.parent.original_line_price ||
                (bundle.parent.original_price ? bundle.parent.original_price * bundle.parent.quantity : 0)

            // For real parents with $0 price, sum children prices
            if (bundleTotal === 0 && !isVirtualParent) {
                bundleTotal = bundle.items.reduce((sum, child) =>
                    sum + (child.final_line_price || (child.price * child.quantity)), 0)
            }

            // Calculate compare-at from children if not set
            if (bundleCompareAt === 0) {
                bundleCompareAt = bundle.items.reduce((sum, child) => {
                    const compareAt = child.selling_plan_allocation?.compare_at_price ||
                        child.product?.variants?.[0]?.compare_at_price ||
                        child.original_line_price ||
                        0
                    return sum + (compareAt * child.quantity)
                }, 0)
            }

            // Create header element (insert before first child, don't move children)
            const header = document.createElement('li')
            header.className = 'bundle-group-header'
            header.setAttribute('data-bundle-id', bundleId)
            header.setAttribute('data-bundle-type', bundleType)

            const badgeText = isOtpBundle ? 'ONE-TIME PURCHASE' : 'SUBSCRIPTION'

            // Collect all item keys upfront for remove button
            const parentKey = !isVirtualParent ? bundle.parent?.key : null
            const childKeys = bundle.items.map(child => child.key)

            header.innerHTML = `
                <span class="bundle-group-title">BUNDLE (${bundleSize} ${bundleSize == 1 ? 'ITEM' : 'ITEMS'})</span>
                <span class="bundle-group-badge ${isOtpBundle ? 'badge-otp' : 'badge-subscription'}">${badgeText}</span>
                <button class="bundle-group-remove" aria-label="Remove bundle"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg></button>
            `

            // Add remove button handler
            header.querySelector('.bundle-group-remove').addEventListener('click', async () => {
                const updates = {}
                if (parentKey) {
                    updates[parentKey] = 0
                }
                childKeys.forEach(key => {
                    updates[key] = 0
                })

                try {
                    await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates })
                    })

                    if (window.Rebuy && window.Rebuy.Cart) {
                        window.Rebuy.Cart.getCart()
                    }
                } catch (error) {
                    console.error('Error removing bundle:', error)
                }
            })

            // Create footer element
            const footer = document.createElement('li')
            footer.className = 'bundle-group-footer'
            footer.setAttribute('data-bundle-id', bundleId)
            const hasDiscount = bundleCompareAt > bundleTotal
            footer.innerHTML = `
                <span class="bundle-group-footer-label">Bundle Total</span>
                <span class="bundle-group-footer-price">
                    ${hasDiscount ? `<span class="bundle-group-compare-at">${cart.formatMoney(bundleCompareAt)}</span>` : ''}
                    <span class="bundle-group-total">${cart.formatMoney(bundleTotal)}</span>
                </span>
            `

            // Insert header before first child, footer after last child
            // Children stay in place - no moving!
            const firstChildEl = childEls[0]
            const lastChildEl = childEls[childEls.length - 1]

            firstChildEl.parentNode.insertBefore(header, firstChildEl)
            lastChildEl.parentNode.insertBefore(footer, lastChildEl.nextSibling)

            // Mark children with classes for styling (don't move them)
            childEls.forEach((childEl, index) => {
                childEl.classList.add('bundle-group-child')
                if (index === 0) childEl.classList.add('bundle-group-first')
                if (index === childEls.length - 1) childEl.classList.add('bundle-group-last')

                // Hide price if $0 - find the price container and check
                const priceContainer = childEl.querySelector('.rebuy-cart__flyout-item-price')
                if (priceContainer) {
                    const priceText = priceContainer.textContent.trim()
                    // Check if price contains $0.00 or $0 (but not $0.50, etc)
                    if (priceText.includes('$0.00') || priceText.match(/\$0(?:\.00)?(?:\s|$)/)) {
                        priceContainer.style.display = 'none'
                    }
                }
            })

            // Hide parent element (only for subscription bundles with real parent)
            if (parentEl) {
                parentEl.classList.add('bundle-group-parent-hidden')
            }
        })
    }
    const deleted = {}
    const deleteCartItems = (cart) => {
        const bundlesObj = getBundles(cart)

        Object.entries(bundlesObj).forEach(([_k, bundle]) => {
            // Skip OTP bundles (intentionally have no parent)
            const isOtpBundle = bundle.items[0]?.properties?._bundle_type === 'otp'
            if (!bundle.parent && !isOtpBundle) {
                // Only delete orphaned subscription bundle children (no parent)
                bundle.items.forEach((item) => {
                    if (!deleted[item.key]) {
                        window.Rebuy.Cart.removeItem(item)
                        deleted[item.key] = true
                    }
                })
            }
        })
    }

    const getBundles = (cart) => {
        const bundles = {}
        cart.items().filter((a) => a.properties && a.properties.bundle_id).forEach(
            (item) => {
                bundles[item.properties.bundle_id] = bundles[item.properties.bundle_id] || { items: [] }
                if (item.properties.bundle_parent)
                    bundles[item.properties.bundle_id].parent = item
                else
                    bundles[item.properties.bundle_id].items.push(item)
            }
        )

        // Create virtual parent for OTP bundles (no real parent in cart)
        Object.entries(bundles).forEach(([bundleId, bundle]) => {
            if (!bundle.parent && bundle.items.length > 0 && bundle.items[0]?.properties?._bundle_type === 'otp') {
                const firstChild = bundle.items[0]
                const totalQuantity = bundle.items.reduce((sum, item) => sum + item.quantity, 0)
                // Create a virtual parent object for consistent handling
                bundle.parent = {
                    key: `virtual-parent-${bundleId}`,
                    variant_id: null,
                    quantity: 1,
                    price: 0,
                    final_line_price: bundle.items.reduce((sum, item) => sum + (item.final_line_price || item.price * item.quantity), 0),
                    original_line_price: bundle.items.reduce((sum, item) => sum + (item.original_line_price || item.price * item.quantity), 0),
                    properties: {
                        bundle_id: bundleId,
                        bundle_parent: true,
                        _bundle_type: 'otp',
                        bundle: firstChild.properties?._bundle || 'Bundle',
                        bundle_size: firstChild.properties?._bundle_size || totalQuantity
                    },
                    selling_plan_allocation: null,
                    _isVirtual: true  // Flag to identify virtual parents
                }
            }
        })

        return bundles;
    }
    const setBundleCart = async (cart) => {
        if (isProcessing) return
        isProcessing = true

        try {
            deleteCartItems(cart)
            await cloneBundles(cart)
            updateCartCount(cart)
            setParentCartValue(cart)
            fixSubtotalCompareAt(cart)
            groupBundleItems(cart)
        } finally {
            isProcessing = false
        }
    }

    // Debounced version to prevent rapid re-calls
    const debouncedSetBundleCart = (cart, delay = 50) => {
        if (debounceTimer) {
            clearTimeout(debounceTimer)
        }
        debounceTimer = setTimeout(() => {
            setBundleCart(cart)
        }, delay)
    }

    // Fallback: update cart count directly from Shopify cart API (when Rebuy isn't available)
    const updateCartCountFallback = async () => {
        try {
            const response = await fetch('/cart.js', {
                headers: { 'Content-Type': 'application/json' }
            })
            const cart = await response.json()

            // Count non-bundle items normally
            let count = cart.items.filter(item => !item.properties || !item.properties.bundle_id).reduce(
                (total, item) => total + item.quantity, 0)

            // Count bundle parents (each parent = 1 bundle)
            const bundles = {}
            cart.items.filter(item => item.properties && item.properties.bundle_id).forEach(item => {
                bundles[item.properties.bundle_id] = bundles[item.properties.bundle_id] || { items: [] }
                if (item.properties.bundle_parent)
                    bundles[item.properties.bundle_id].parent = item
                else
                    bundles[item.properties.bundle_id].items.push(item)
            })
            count += Object.entries(bundles).filter(([_k, bundle]) => bundle.parent).reduce(
                (total, [_k, bundle]) => total + bundle.parent.quantity, 0)

            // Also count OTP bundles (no parent, grouped by bundle_id)
            count += Object.entries(bundles).filter(([_k, bundle]) => !bundle.parent && bundle.items.length > 0 && bundle.items[0]?.properties?._bundle_type === 'otp').length

            const countEl = document.querySelector(".cart-menu .count")
            if (countEl) countEl.innerText = count

            const headerCountEl = document.querySelector("[data-header-cart-count]")
            if (headerCountEl) headerCountEl.textContent = count
        } catch (error) {
            console.error('Error updating cart count fallback:', error)
        }
    }

    document.addEventListener('rebuy:cart.change', function (event) {
        // Use debounced call with retry for DOM updates
        debouncedSetBundleCart(event.detail.cart, 50)
        // Single delayed retry for DOM that may not be ready
        setTimeout(() => {
            if (!isProcessing) {
                groupBundleItems(event.detail.cart)
            }
        }, 300)
    });

    document.addEventListener('rebuy:cart.ready', function (event) {
        setBundleCart(event.detail.cart)
    });

    const productForm = document.querySelector("product-form")
    if (productForm) {
        productForm.addEventListener("add-to-cart", () => {
            // Delay to allow Rebuy to update cart
            setTimeout(() => {
                if (window.Rebuy && window.Rebuy.Cart) {
                    window.Rebuy.Cart.getCart()
                } else {
                    // Rebuy not available, update count directly
                    updateCartCountFallback()
                }
            }, 100)
        })
    }

    // MAIVINO CUSTOM - Native cart bundle support (when Rebuy isn't available)
    const bindNativeBundleRemoveHandlers = () => {
        document.querySelectorAll('.native-bundle-remove').forEach(btn => {
            if (btn.dataset.bound) return
            btn.dataset.bound = 'true'
            btn.addEventListener('click', async (e) => {
                e.preventDefault()
                const keys = btn.dataset.bundleKeys
                if (!keys) return

                const updates = {}
                keys.split(',').forEach(key => {
                    updates[key.trim()] = 0
                })

                btn.disabled = true
                btn.style.opacity = '0.5'

                try {
                    await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates })
                    })

                    if (window.Rebuy && window.Rebuy.Cart) {
                        window.Rebuy.Cart.getCart()
                    } else {
                        await refreshNativeCart()
                    }
                } catch (error) {
                    console.error('Error removing bundle:', error)
                    btn.disabled = false
                    btn.style.opacity = ''
                }
            })
        })
    }

    // Refresh native cart HTML via section rendering (same pattern as theme's CartForm.updateCartQty)
    const refreshNativeCart = async () => {
        try {
            const response = await fetch('?section_id=helper-cart')
            const text = await response.text()
            const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html')

            const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm')
            const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal')

            if (cartFormInnerHTML) {
                const cartItems = document.getElementById('AjaxCartForm')
                if (cartItems) {
                    cartItems.innerHTML = cartFormInnerHTML.innerHTML
                    if (typeof cartItems.ajaxifyCartItems === 'function') {
                        cartItems.ajaxifyCartItems()
                    }
                    // NOTE: Do NOT copy [data-cart-count] to header here — it contains
                    // the raw cart.item_count which doesn't account for bundle grouping.
                    // updateCartCountFallback() below will set the correct bundle-aware count.
                }
            }

            if (cartSubtotalInnerHTML) {
                const subtotalEl = document.getElementById('AjaxCartSubtotal')
                if (subtotalEl) {
                    subtotalEl.innerHTML = cartSubtotalInnerHTML.innerHTML
                }
            }

            // Re-bind native bundle remove handlers after HTML replacement
            bindNativeBundleRemoveHandlers()

            // Update cart count with bundle-aware logic
            await updateCartCountFallback()
        } catch (error) {
            console.error('Error refreshing native cart:', error)
        }
    }

    // Open native cart sidebar
    // NOTE: We intentionally do NOT call siteCart.show() because rebuy-extensions.liquid
    // overrides it to call openRebuyCart(), which would create an infinite loop when
    // Rebuy isn't available. Instead, we directly manipulate the DOM.
    const openNativeCart = () => {
        const siteCart = document.querySelector('[data-js-site-cart-sidebar]')
        if (siteCart) {
            // Remove smart-cart--enabled class so native sidebar can display
            document.body.classList.remove('smart-cart--enabled')
            // Ensure the sidebar and overlay are visible
            siteCart.style.display = 'block'
            siteCart.style.height = window.innerHeight + 'px'
            setTimeout(() => { siteCart.classList.add('active') }, 10)
            const overlay = document.getElementById('site-overlay')
            if (overlay) {
                overlay.style.display = ''
                overlay.style.visibility = ''
                overlay.classList.add('active')
            }
            document.body.classList.add('sidebar-move')
            document.querySelector('html').classList.add('kill-overflow')
        }
    }

    // Expose functions globally for lsg-bundle.js to use
    window.nativeBundleCart = {
        refresh: refreshNativeCart,
        open: openNativeCart,
        updateCount: updateCartCountFallback
    }

    // Listen for bundle add-to-cart (from lsg-bundle.js) when Rebuy isn't available
    // Poll for Rebuy availability, and if not loaded after 5s, set up fallback listeners
    let countUpdateTimer = null
    const debouncedCountUpdate = () => {
        if (countUpdateTimer) clearTimeout(countUpdateTimer)
        countUpdateTimer = setTimeout(updateCartCountFallback, 400)
    }

    setTimeout(() => {
        if (!window.Rebuy) {
            // Rebuy didn't load - update count on page load and watch for cart changes
            updateCartCountFallback()

            // Bind native bundle remove handlers
            bindNativeBundleRemoveHandlers()

            // Observe fetch calls to /cart/add.js to trigger count updates
            const originalFetch = window.fetch
            window.fetch = function() {
                const result = originalFetch.apply(this, arguments)
                const url = arguments[0]
                if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/change.js') || url.includes('/cart/update.js'))) {
                    result.then(() => {
                        debouncedCountUpdate()
                    })
                }
                return result
            }
        }
    }, 5000)

})()
